import { dayjs } from "@/core/utils/date";
import {
  DEFAULT_POLL_TIMEOUT_MS,
  type PollingResult,
} from "@/payroll/pay-breakdown/payroll-statement-notifications/polling";
import type { PayrollStatementProjectionBuild } from "@/payroll/pay-breakdown/payroll-statement-notifications/types";

export const isProjectionBuildStalled = (
  build: PayrollStatementProjectionBuild | null | undefined,
  now = dayjs(),
) =>
  build?.status === "pending" &&
  !!build.started_at &&
  now.diff(dayjs(build.started_at)) >
    (build.poll_timeout_ms ?? DEFAULT_POLL_TIMEOUT_MS);

const displayedBuild = ({
  indexBuild,
  polledBuild,
}: {
  indexBuild: PayrollStatementProjectionBuild | null | undefined;
  polledBuild:
    | PollingResult<PayrollStatementProjectionBuild>
    | null
    | undefined;
}): PollingResult<PayrollStatementProjectionBuild> | null => {
  if (
    polledBuild?.status === "ready" &&
    indexBuild?.status !== "ready" &&
    indexBuild
  ) {
    return indexBuild;
  }

  return polledBuild ?? indexBuild ?? null;
};

export const getDisplayedProjectionBuild = (builds: {
  indexBuild: PayrollStatementProjectionBuild | null | undefined;
  polledBuild:
    | PollingResult<PayrollStatementProjectionBuild>
    | null
    | undefined;
}): PollingResult<PayrollStatementProjectionBuild> | null => {
  const build = displayedBuild(builds);
  return build && !build.polling_timed_out && isProjectionBuildStalled(build)
    ? { ...build, polling_timed_out: true }
    : build;
};
